"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Twitter, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socials = [{
  name: "Facebook",
  icon: Facebook,
  href: "#"
}, {
  name: "Twitter",
  icon: Twitter,
  href: "#"
}, {
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "LinkedIn",
  icon: Linkedin,
  href: "#"
}];
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        {["Holdings", "Strategy", "Portfolio", "Innovation"].map((service, i) => <li key={i} data-index={i}>
            <Link to={service === "Holdings" ? "/HoldingsPage" : service === "Strategy" ? "/StrategyPage" : "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group">
              <ChevronRight className="size-3 text-primary/50 group-hover:text-primary transition-colors" />
              {service}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group">
            <ChevronRight className="size-3 text-primary/50 group-hover:text-primary transition-colors" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="206508" id="footer" className="dark bg-background text-foreground pt-16 pb-8 relative overflow-hidden border-t border-border/20">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-primary/30 to-transparent shadow-[0_0_30px_rgba(var(--color-primary),0.3)]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          
          {}
          <div className="md:col-span-5 flex flex-col gap-6">
            <Link to="#" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/dorroughs_hvac_footer_logo.png" alt="Eagle 47 Logo" className="h-7 w-auto drop-shadow-[0_0_8px_rgba(var(--color-primary),0.2)]" />
            </Link>
            
            <Badge variant="outline" className="w-fit border-primary/50 text-primary bg-primary/5 backdrop-blur-sm shadow-[0_0_15px_rgba(var(--color-primary),0.15)] px-3 py-1 text-xs tracking-wider font-mono uppercase">
              Sovereign Holdings
            </Badge>
            
            <p className="text-muted-foreground text-sm max-w-sm leading-relaxed">
              Strategic holdings and smart-contracting infrastructure. Unifying modern software ventures and digital assets into a single, scalable ecosystem built for the next era.
            </p>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-wide text-foreground flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-secondary shadow-[0_0_8px_rgba(var(--color-secondary),0.6)]" />
              Strategic Assets
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-wide text-foreground flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-primary shadow-[0_0_8px_rgba(var(--color-primary),0.6)]" />
              Institutional Access
            </h3>
            
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 group">
                <div className="p-2 rounded-md bg-input/30 border border-border/50 group-hover:border-primary/50 group-hover:bg-primary/10 transition-all">
                  <Phone className="size-4 text-primary" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-muted-foreground uppercase tracking-wider font-mono mb-0.5">Global Operations</span>
                  <Link to="tel:+1800EAGLE47" className="text-sm font-medium hover:text-primary transition-colors">
                    +1 (800) EAGLE-47
                  </Link>
                </div>
              </li>
              
              <li className="flex items-start gap-3 group">
                <div className="p-2 rounded-md bg-input/30 border border-border/50 group-hover:border-primary/50 group-hover:bg-primary/10 transition-all">
                  <MapPin className="size-4 text-primary" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-muted-foreground uppercase tracking-wider font-mono mb-0.5">Digital Infrastructure</span>
                  <span className="text-sm font-medium">
                    Zurich • New York • Distributed
                  </span>
                </div>
              </li>
            </ul>

            <div className="flex gap-3 mt-2">
              {socials.map((social, i) => <Link key={social.name} to={social.href} data-index={i} className="p-2.5 rounded-md border border-border/50 bg-input/20 text-muted-foreground hover:text-primary hover:border-primary/50 hover:bg-primary/10 hover:shadow-[0_0_15px_rgba(var(--color-primary),0.2)] transition-all duration-300 inline-flex items-center justify-center" aria-label={social.name}>
                  <social.icon className="size-4" strokeWidth={1.5} />
                </Link>)}
            </div>
          </div>
          
        </div>

        {}
        <div className="relative pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          {}
          <div className="absolute top-0 left-0 w-full h-px bg-primary/40 shadow-[0_0_10px_rgba(var(--color-primary),0.5)]" />
          
          <p className="text-xs text-muted-foreground font-mono">
            © {new Date().getFullYear()} Eagle 47 Holdings. All protocols active.
          </p>
          
          <div className="flex gap-6 text-xs text-muted-foreground font-mono">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Protocol
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Engagement
            </Link>
          </div>
        </div>
      </div>
    </section>;
}